import React from 'react';
import PropTypes from 'prop-types';
import Theme from '../../themes';

const { borderRadius } = Theme.global;
const { borderColor, placeholderColor, errorBorderColor } = Theme.forms.inputs;

class Input extends React.PureComponent {
  render() {
    const {
      name,
      type,
      value,
      checked,
      onChange,
      onBlur,
      placeholder,
      hasError,
      style,
    } = this.props;

    return (
      <span>
        <input
          name={name}
          id={name}
          data-test={name}
          type={type}
          value={value}
          checked={checked}
          className={hasError ? 'error' : null}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          style={style}
        />
        <style jsx>
          {`
            span {
              display: inline-block;
              width: 100%;
            }
            input {
              border: 1px solid ${borderColor};
              border-radius: ${borderRadius};
              padding: 0.65em;
              width: 100%;
            }
            input::placeholder {
              color: ${placeholderColor};
            }
            input.error::placeholder {
              color: ${errorBorderColor};
            }
            input.error {
              border-color: ${errorBorderColor};
            }
          `}
        </style>
      </span>
    );
  }
}

Input.defaultProps = {
  style: null,
  placeholder: null,
  value: undefined,
  hasError: false,
  onBlur: null,
  checked: false,
};

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'number', 'search', 'email', 'tel', 'checkbox']).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  style: PropTypes.object,
};

export default Input;



// WEBPACK FOOTER //
// ./app/common/forms/Input.js